import * as SQLite from 'expo-sqlite';
import { Platform } from 'react-native';

import * as FileSystem from "expo-file-system";

const findTable = (sql: string) => {
  const query = sql.split(' ');
  const table = query.at(query.indexOf('from') + 1);
  
  return table?.endsWith(';') ? table.substring(0, table.length - 1) : table;
}

const findParams = (sql: string, args: (string | number | null)[] | undefined) => {
  const query = sql.split(' ');
  const filters = query.filter((item) => item.includes('='));
  const params: string[] = [];
  if (args && args.length === filters.length) {
    filters.forEach((item, index) => {
      const [ key, value ] = item.split('=');
      params.push(`${key}=${args[index]}`);
    });
  }
  return params.join('&');
}

const internalDbName = "dbInStorageV003.sqlite";
const urlHymn = 'https://hymns.nyc3.cdn.digitaloceanspaces.com/db/hymnalV003.db';
const urlApi = 'https://himnariojuvenil.org/backend/api/';

export async function openDatabase () {
  if (Platform.OS === "web") {
    return {
      transaction: (callback: any) => {
        if (typeof callback === 'function') {
          callback({
            executeSql: async (sql: string, args?: (string | number | null)[] | undefined, callback?: any | undefined) => {
              if (typeof callback === 'function') {
                const table = findTable(sql);
                let url = urlApi + table;
                const params = findParams(sql, args)
                if (params.length) {
                  url += `?${params}`;
                }
                const response = await fetch(url)
                const _array: any[] = await response.json();
                callback(null, { rows: { _array } });
              }
            }
          });
        }
      },
    };
  }

  const sqlDir = FileSystem.documentDirectory + "SQLite/";
  if (!(await FileSystem.getInfoAsync(sqlDir + internalDbName)).exists) {
    await FileSystem.makeDirectoryAsync(sqlDir, { intermediates: true });
    await FileSystem.downloadAsync(urlHymn, sqlDir + internalDbName);
  }
  const db = SQLite.openDatabase(internalDbName);
  return db;
}
